<template>
  <div>
    <p class="mb-3">
      當實際銷售收益已達 港幣$1,000 及符合收款要求，你可以點撃按鈕以電郵通知方式向我們申請收款。每月只可以申請收款一次，是次申請後可於截數日後再次申請。
    </p>
    <p>申請步驟：</p>
    <p>步驟1：符合收款申請條件，並向我們申請 (每月20日23:59截數)</p>
    <p>步驟2：本公司核對帳目及處理收款申請 (約為3星期)</p>
    <p class="mb-3">步驟3：於3星期內收到銀行入數，並於本平台收款狀態顯示，商戶可自行下載收款狀態。</p>
  </div>
</template>

<script>

export default {
  components: {
  },
  methods: {
    handleModalHidden() {
      if (this.inputVal.action === 'REMOVE') {
        this.$router.replace(this.inputVal.back.location);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  p {
    margin:0px;
  }
</style>
